<style>
.list-group-item2 {
    position: relative;
    /* display: block; */
    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
    color: var(--bs-list-group-color);
    text-decoration: none;
    background-color: var(--bs-list-group-bg);
    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
</style>
<template>
    <div class="app-layout">
        <!-- Componente de la barra de navegación -->
        <NavBar :collapsed="collapsed" :pinned="pinned" @update:collapsed="updateCollapsed"
            @update:pinned="updatePinned" />
        <!-- Contenido principal -->

        <main :class="{ 'main-collapsed': collapsed, 'main-expanded': !collapsed || pinned }">
            <BarTop />
            <div class="pt-2 px-3">
                <div class="py-4">
                    <h2 class="">Servicios por cobrar</h2>
                    <p>Servicios que serán cobrados al cliente por la gestión de los despachos.</p>
                    <div class="text-end">
                        <a class="btn btn-success" href="serviciosCobrar/crear">Agregar servicio por cobrar</a>
                    </div>

                </div>
                <p>Filtros</p>
                <div class="m-3 row">
                    <div class="col-md-2 mb-4">
                        <label for="rut" class="form-label">Rut cliente</label>
                        <input type="text" class="form-control" :class="{ 'border-danger': dataForm.rut.err }" id="rut"
                            placeholder="Use solo números y guión" @input="handleRutInput" v-model="dataForm.rut.value">
                        <span v-if="dataForm.rut.err" class="text-danger">Debe ingresar un
                            rut</span>
                    </div>
                    <div class="col-md-2 mb-4">
                        <label for="shipping_number" class="form-label">Nro despacho</label>
                        <input type="text" class="form-control"
                            :class="{ 'border-danger': dataForm.shipping_number.err }" id="shipping_number"
                            placeholder="" v-model="dataForm.shipping_number.value">
                        <span v-if="dataForm.shipping_number.err" class="text-danger">Debe ingresar un
                            número de despacho</span>
                    </div>
                    <div class="col-md-2 mb-4">
                        <label for="booking_number" class="form-label">Nro reserva</label>
                        <input type="text" class="form-control"
                            :class="{ 'border-danger': dataForm.booking_number.err }" id="booking_number" placeholder=""
                            v-model="dataForm.booking_number.value">
                        <span v-if="dataForm.booking_number.err" class="text-danger">Debe ingresar un
                            número de reserva</span>
                    </div>
                    <div class="col-md-2 mb-4">
                        <label for="document_number" class="form-label">Nro de factura</label>
                        <input type="text" class="form-control"
                            :class="{ 'border-danger': dataForm.document_number.err }" id="document_number"
                            placeholder="" v-model="dataForm.document_number.value">
                        <span v-if="dataForm.document_number.err" class="text-danger">Debe ingresar un
                            número de documento</span>
                    </div>
                    <div class="col-md-2 mb-4">
                        <label for="amount" class="form-label">Monto</label>
                        <input type="text" class="form-control" :class="{ 'border-danger': dataForm.amount.err }"
                            id="amount" placeholder="" v-model="dataForm.amount.value">
                        <span v-if="dataForm.amount.err" class="text-danger">Debe ingresar un monto</span>
                    </div>
                    <div class="col-md-2 mt-4">
                        <div class="text-end">
                            <span class="mx-1">
                                <a class="btn btn-success" @click="filter()">Filtrar</a>
                            </span>
                            <a class="btn btn-success" @click="deleteFilters()">Limpiar filtros</a>
                        </div>
                    </div>
                </div>
                <div>
                    <vue3-datatable :no-data-content="'No se encontraron resultados.'" :search="search" :rows="items"
                        :columns="columns" order :sortable="true" :sort-column="sortColumn"
                        :sort-direction="sortDirection" :is-server-mode="true" :page="page" :page-size="perPage"
                        :total-rows="totalRows" :loading="loading" @change="onTableChange">
                        <template #total_con_iva="data">
                            <span>{{ data.value.total_con_iva > 0 ? formatCurrency(data.value.total_con_iva,
            data.value.initials) : 0
                                }}</span>
                        </template>
                        <template #deuda_original_con_iva="data">
                            <span>{{ data.value.deuda_original_con_iva > 0 ?
            formatCurrency(data.value.deuda_original_con_iva, data.value.initials) : 0
                                }}</span>
                        </template>

                        <template #value_payment="data">
                            <span>{{ data.value.value_payment > 0 ? formatCurrency(data.value.value_payment,
            data.value.value_payment_initials) : 0 }}</span>
                        </template>

                        <template #deuda_original_neto="data">
                            <span>{{ data.value.deuda_original_neto > 0 ? formatCurrency(data.value.deuda_original_neto,
            data.value.initials) : 0
                                }}</span>
                        </template>

                        <template #rut="row">
                            <td style=" text-align: end; white-space: nowrap;">{{ row.value.rut }}</td>
                        </template>
                        <!-- Celda personalizada -->
                        <template #date_fee="row">
                            <td style=" text-align: end; white-space: nowrap;">{{ row.value.date_fee }}</td>
                        </template>
                        <template #actions="data">
                            <div class="text-center">
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        Acciones
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li @click="showService(data.value)"><a class="dropdown-item" href="#"> <i
                                                    class="bi bi-eye px-2"></i>Ver</a></li>
                                        <li @click="addPartialPayment(data.value)"><a class="dropdown-item" href="#"> <i
                                                    class="bi bi-plus-circle px-2"></i>Abonar</a></li>
                                        <li @click="editService(data.value)"><a class="dropdown-item" href="#"> <i
                                                    class="bi bi-pencil px-2"></i>Editar</a></li>
                                        <li @click="showHistorial(data.value.id_cs_fee);"><a class="dropdown-item"
                                                href="#"> <i class="bi bi-card-list px-2"></i>Historial</a></li>
                                    </ul>
                                </div>
                            </div>
                        </template>
                    </vue3-datatable>
                </div>
            </div>
        </main>
        <!-- Ver -->
        <div class="modal-mb" v-if="verModal">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class="modal-title text-black col-11" id="exampleModalLabel">Servicio por cobrar</h5>
                        <button type="button" class="btn-close col" data-bs-dismiss="modal" @click="closeModal2()"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body mt-4" style="overflow-y: auto; height: 60vh">
                        <div class="card p-4">
                            <div class="row">
                                <div class="col-md-4">
                                    <b>Identificador</b>
                                    <p>{{ service.id_cs_fee }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Número de despacho</b>
                                    <p>{{ service.shipping_number }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Estado</b>
                                    <p>{{ service.status_name }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Fecha de creación</b>
                                    <p>{{ service.date_fee }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Rut cliente</b>
                                    <p>{{ service.rut }}</p>
                                </div>

                                <br>
                                <div class="col-md-4">
                                    <b>Monto sin IVA</b>
                                    <p>{{ service.deuda_original_neto > 0 ?
            formatCurrency(service.deuda_original_neto,
                service.initials) : 0 }}</p>
                                </div>

                                <div class="col-md-4">
                                    <b>Monto con IVA</b>
                                    <p>{{ service.deuda_original_con_notas > 0 ?
            formatCurrency(service.deuda_original_con_iva,
                service.initials) : 0 }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Monto impago</b>
                                    <p>{{ service.total_con_iva > 0 ?
            formatCurrency(service.total_con_iva,
                service.initials) : 0 }}</p>
                                </div>

                            </div>
                            <br>
                            <div>
                                <h6>Conceptos Asociados a la factura</h6>
                                <div>
                                    <!-- Lista de ítems agregados -->
                                    <ul class="list-group mt-3" v-if="invoice_concepts.length">
                                        <li class="list-group-item d-flex justify-content-between align-items-center"
                                            v-for="(it, idx) in invoice_concepts" :key="it.key">
                                            <span><strong>Item {{ idx + 1 }}:</strong> {{ it.label }}</span>
                                        </li>
                                    </ul>
                                    <div v-else>
                                        <h4>Sin conceptos asociados</h4>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <h6 v-if="service.bank_account_origin">DATOS DE PAGO EFECTUADO AL MOMENTO DE ABONAR
                            </h6>
                            <br>
                            <div class="row" v-if="service.bank_account_origin">
                                <div class="col-md-4">
                                    <b>Banco</b>
                                    <p>{{ service.bank }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Método de pago</b>
                                    <p>{{ service.payment_method == 1 ? 'Transferencia electronica' : '' }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Número de cuenta</b>
                                    <p>{{ service.bank_account_origin }}</p>
                                </div>

                            </div>

                            <br>

                            <template v-if="dataUrl">
                                <h6 class="mt-4">ARCHIVO ADJUNTO</h6>
                                <br>
                                <div class="card p-3 text-center" style="width:140px">
                                    <!-- preview imagen -->
                                    <img v-if="isImage" :src="dataUrl" class="img-fluid mb-2"
                                        style="object-fit:cover;max-height:90px" />

                                    <!-- icono PDF u otro -->
                                    <i v-else class="bi bi-file-earmark-pdf-fill display-4 text-danger mb-2"></i>

                                    <small class="d-block text-truncate">{{ filename }}</small>

                                    <button class="btn btn-outline-primary btn-sm w-100 mt-2" @click="openFile">
                                        Abrir
                                    </button>
                                </div>
                            </template>
                            <br>
                            <div>
                                <h5 class="mt-4">SHIPPING ASOCIADOS</h5>
                                <br>
                                <vue3-datatable :noDataContent="'No se encontraron resultados.'" v-if="shippings.length"
                                    class="mb-4" :rows="shippings" :columns="columnsShipping" :search="''"
                                    :sortable="false" :per-page="5">

                                </vue3-datatable>
                                <p v-else class="text-muted">— Sin despachos asociados —</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            @click="closeModal2()">Cerrar</button>

                    </div>
                </div>
            </div>
        </div>
        <!-- Historial-->
        <div class="modal-mb" v-if="verHistorial">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class="modal-title text-black col-11" id="exampleModalLabel">Historial de pagos</h5>
                        <button type="button" class="btn-close col" data-bs-dismiss="modal" @click="closeModal()"
                            aria-label="Cerrar"></button>
                    </div>
                    <div class="modal-body mt-4">
                        <div class="card">
                            <div class="row mx-4">
                                <div class="col-md-2 mb-4">
                                    <label for="historialType" class="form-label">Tipo</label>
                                    <select id="historialType" class="form-select" v-model="historialType"
                                        aria-label="Seleccione un tipo">
                                        <option value="">Ver todos</option>
                                        <option :value="1">Servicio por cobrar</option>
                                        <option :value="5">Servicio por cobrar (abono directo)</option>
                                        <option :value="6">Servicio por cobrar (abono por provisión)</option>
                                    </select>
                                </div>
                                <div class="col-md-2 mt-4 text-end">
                                    <button class="btn btn-success" @click="filterHistory()">Filtrar</button>
                                </div>
                            </div>
                            <div>
                                <vue3-datatable :noDataContent="'No se encontraron resultados.'" :search="search"
                                    :rows="payments" :columns="columns2" order :sortable="true" :sortColumn="'ID'">
                                    <template #deuda_original_neto="data">
                                        <span>{{ formatCurrency(data.value.deuda_original_neto, data.value.initials)
                                            }}</span>
                                    </template>

                                    <template #deuda_original_con_iva="data">
                                        <span>{{ formatCurrency(data.value.deuda_original_con_iva, data.value.initials)
                                            }}</span>
                                    </template>

                                    <template #value_payment="data">
                                        <span v-if="data.value.value_payment != 0">
                                            {{ formatCurrency(data.value.value_payment,
            data.value.value_payment_initials) }}
                                        </span>
                                        <span v-else>
                                            {{ formatCurrency(0.00, data.value.initials) }}
                                        </span>
                                    </template>

                                    <template #unpaid_amount="data">
                                        <span v-if="data.value.unpaid_amount != 0">

                                            {{ formatCurrency(
            data.value.unpaid_amount,
            data.value.value_unpaid_initials) }}
                                        </span>
                                        <span v-else>

                                            {{ formatCurrency(0.00, data.value.initials) }}
                                        </span>
                                    </template>

                                    <template #pago_parcial="data">
                                        <span v-if="data.value.pago_parcial != 0">
                                            {{ formatCurrency(
            data.value.pago_parcial,
                                            data.value.value_unpaid_initials) }}
                                        </span>
                                        <span v-else>
                                            {{ formatCurrency(0.00, data.value.initials) }}
                                        </span>
                                    </template>

                                    <template #rut="data">
                                        <td style="text-align: end; white-space: nowrap;">{{ data.value.rut }}</td>
                                    </template>

                                    <template #date="data">
                                        <td style="text-align: end; white-space: nowrap;">{{ data.value.date }}</td>
                                    </template>

                                    <template #select="data">
                                        <button @click="toggleSelectionBoard(data.value)"
                                            aria-label="Seleccionar o deseleccionar">
                                            {{ isSelectedBoard(data.value) ? 'Desasociar' : 'Asociar' }}
                                        </button>
                                    </template>
                                </vue3-datatable>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            @click="closeModal()">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

import { ref } from "vue";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import "@bhplugin/vue3-datatable/dist/style.css";
import NavBar from './../component/NavBar.vue';
import BarTop from './../component/BarTop.vue';
export default {
    components: {
        Vue3Datatable,
        NavBar,
        BarTop
    },
    data() {
        return {
            loading: false,
            search: '',
            page: 1,
            perPage: 20,
            totalRows: 0,
            sortColumn: 'date_origin',   // usa el campo que tu API soporte por defecto
            sortDirection: 'desc',
            theme: localStorage.getItem('theme') || 'light-mode',
            collapsed: true,
            pinned: localStorage.getItem('pinned') == 'false' ? false : true || false,
            options: {
                responsive: true,
                maintainAspectRatio: false,
            },
            service: {},
            verModal: false,
            verHistorial: false,
            historialType: '',
            idHistory: 0,
            items: [

            ],
            invoice_concepts: [],
            shippings: [],
            columnsShipping: [             // orden y títulos solicitados
                { field: 'shipping_number', title: 'Número Despacho' },
                { field: 'date_shipping', title: 'Fecha' },
                { field: 'week', title: 'Semana' },
                { field: 'rut', title: 'Rut cliente' },
                { field: 'boarding_number', title: 'Número de embarque' },
                { field: 'booking_number', title: 'Número de reserva' },
                { field: 'container_number', title: 'Número de container' },
                { field: 'type_operation', title: 'Tipo operación' },
                { field: 'type_board', title: 'Tipo embarque' },
                { field: 'consignee', title: 'Despachador' },
                { field: 'aduana', title: 'Aduana' },
                { field: 'vessel', title: 'Vessel' },
                { field: 'consignee', title: 'Consignatario' },
                { field: 'bailment', title: 'Comodato' },
                { field: 'port_departure_shipment', title: 'Puerto embarque' },
                { field: 'country_destination', title: 'País destino' },
            ],
            dataForm: {
                rut: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                shipping_number: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                document_number: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                booking_number: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                amount: {
                    value: 0,
                    err: false,
                    msjErr: ''
                },
            }, columns2: [
                { field: "id_balance", title: "ID" },
                { field: "shipping_number", title: "Nro. de despacho" },
                { field: "date", title: "Fecha" },
                { field: "week_number", title: "Número de semana" },
                { field: "table_type", title: "Tipo" },
                { field: "bill_number", title: "Nota de cobro" },
                { field: "rut", title: "RUT cliente" },
                { field: "status_name", title: "Estado" },
                { field: "concept", title: "Concepto" },
                { field: "deuda_original_neto", title: "Monto original neto" },
                { field: "deuda_original_con_iva", title: "Monto con iva y notas" },
                { field: "value_payment", title: "Monto abonado" },
                // { field: "unpaid_amount", title: "Monto impago (neto)" },
                { field: "unpaid_amount", title: "Monto impago" }, // calculado
                { field: "bank_account_origin", title: "Cuenta de origen" },
                { field: "bank", title: "Banco" },
                { field: "payment_method", title: "Método de pago" }
            ],
            columns: [
                { field: "id_cs_fee", title: "ID" },

                { field: "date_origin", title: "Fecha" },
                { field: "week_number_origin", title: "Número de semana" },
                { field: "bill_number", title: "Factura" },

                { field: "rut", title: "RUT cliente" },
                { field: "status_name", title: "Estado" },

                { field: "deuda_original_neto", title: "Monto original neto" },
                { field: "deuda_original_con_iva", title: "Monto con IVA y notas" },
                { field: "value_payment", title: "Último monto abonado" },
                { field: "date", title: "Fecha último abono" },
                { field: "total_con_iva", title: "Monto impago actual" },

                { field: "actions", title: "" }
            ],
            rawFile: '',      // base-64 sin encabezado
            mimeType: '',      // p.e. 'application/pdf'
            filename: '',
        }
    },
    mounted() {
        this.getAR()
        document.body.className = this.theme;

    },
    computed: {
        /* preview listo para <img> o window.open */
        dataUrl() {
            return this.rawFile
                ? `data:${this.mimeType};base64,${this.rawFile}`
                : ''
        },
        isImage() {                 // ¿mostrar miniatura?
            return this.mimeType.startsWith('image/')
        }
    },
    methods: {
        onTableChange(payload) {
            // console.log('change payload =>', payload)
            this.page = Number(payload.current_page ?? payload.page ?? this.page) || 1;
            this.perPage = Number(payload.pagesize ?? payload.pageSize ?? this.perPage) || this.perPage;
            this.sortColumn = payload.sort_column ?? payload.sortColumn ?? this.sortColumn;
            this.sortDirection = payload.sort_direction ?? payload.sortDirection ?? this.sortDirection;

            this.filter();
        },
        weekNumber(isoDate) {               // yyyy-mm-dd  →  nº semana (ISO-8601)
            const d = new Date(isoDate)
            d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
            const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
            return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
        },

        enrichShippings(raw) {              // completa campos que no vienen
            return raw.map(s => ({
                ...s,
                week: this.weekNumber(s.date_shipping),
                rut: this.service.rut,                 // viene en el servicio
                boarding_number: s.id_boarding ?? '',              // alias amistoso
                vessel: s.vessel ?? '',                   // (si tu API lo expone)
            }))
        },
        /** abre el adjunto en otra pestaña, evitando data-urls gigantes */
        openFile() {
            if (!this.rawFile) return       // nada que mostrar

            const blob = this.base64ToBlob(this.rawFile, this.mimeType)
            const url = URL.createObjectURL(blob)

            // nueva pestaña/ventana
            window.open(url, '_blank', 'noopener,noreferrer')

            // libera memoria cuando el usuario cierre la pestaña
            setTimeout(() => URL.revokeObjectURL(url), 60_000)
        },

        /** util: base-64 (sin encabezado) -> Blob */
        base64ToBlob(b64, mime) {
            const byteChars = atob(b64)
            const byteNumbers = new Array(byteChars.length)
            for (let i = 0; i < byteChars.length; i++)
                byteNumbers[i] = byteChars.charCodeAt(i)

            const byteArray = new Uint8Array(byteNumbers)
            return new Blob([byteArray], { type: mime || 'application/octet-stream' })
        },
        filter() {
            this.loading = true;

            const params = {
                page: this.page,
                per_page: this.perPage,
                rut: this.dataForm.rut.value,
                nroDespacho: this.dataForm.shipping_number.value,
                nroFactura: this.dataForm.document_number.value,
                nroReserva: this.dataForm.booking_number.value,
                monto: this.dataForm.amount.value,
                sort_by: this.sortColumn,
                sort_dir: this.sortDirection,
            };

            axios.post('/api/services-to-be-collected', params, {
                headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
            })
                .then(({ data, status }) => {
                    if (status === 200) {
                        this.items = data.data || [];
                        this.totalRows = Number(data.total ?? 0);
                        if (data.per_page) this.perPage = Number(data.per_page);       // opcional
                        if (data.current_page) this.page = Number(data.current_page);   // opcional
                    } else {
                        this.items = [];
                        this.totalRows = 0;
                    }
                })
                .catch(err => {
                    if (err.response?.statusText === 'Unauthorized') {
                        localStorage.removeItem('accessToken');
                        window.location.href = './../../api/auth/logout';
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.$swal?.close?.();
                });
        },

        addPartialPayment(data) {
            this.$swal({
                title: "¿Deseas abonar este pago?",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: "Abonar",
                cancelButtonText: 'Cancelar',
                denyButtonText: `Abonar desde provisiones`
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    window.location.href = 'serviciosCobrar/abonar/' + data.id_cs_fee + '/' + data.id_client;
                } else if (result.isDenied) {
                    this.getSupply(data)
                }
            });

        },
        async getSupply(data) {
            const self = this;
            try {
                const response = await axios.get('/api/clientSupply/' + data.id_client, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                let supply = response.data; // Array de objetos con el campo "amount"

                // Suma de todos los amounts (asegurándonos de que sean numéricos)
                let totalAmount = supply.reduce((acc, item) => {
                    return acc + Number(item.amount);
                }, 0);

                if (totalAmount > 0) {
                    // Redirige si la suma es mayor que 0
                    window.location.href = 'serviciosCobrar/provisionabonar/' + data.id_cs_fee + '/' + data.id_client;
                } else {
                    // Muestra mensaje si no hay saldo
                    this.$swal.fire({
                        icon: 'info',
                        title: 'Sin saldo disponible',
                        text: 'No cuentas con saldo en tus provisiones',
                        confirmButtonText: 'OK'
                    });
                }

            } catch (error) {
                console.error('Error fetching supply:', error);
            }
        },
        async filterHistory() {
            let id = this.idHistory;
            let self = this;
            self.verHistorial = false;
            this.$swal({
                title: 'Obteniendo historial de abonos'
            });
            this.$swal.showLoading();
            try {
                let params = {
                    tipo: this.historialType
                }
                const response = await axios.post('/api/services-history-noship/' + id, params, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                if (response) {
                    this.$swal.close();
                    self.verHistorial = true;
                }


                self.payments = response.data.data;

            } catch (error) {
                console.error('Error fetching concepts:', error);
            }
        },
        async showHistorial(id) {
            this.idHistory = id;
            this.historialType = '';
            try {
                let params = {
                    tipo: ''
                }
                const response = await axios.post('/api/services-history-noship/' + id, params, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                this.verHistorial = true;



                this.payments = response.data.data;
            } catch (error) {
                console.error('Error fetching concepts:', error);
            }

        },
        showService(value) {
            this.$swal.update({ title: 'Cargando data de servicio por cobrar...' });
            this.$swal.showLoading();

            this.service = value;

            this.getService(value.id_cs_fee);
        },
        async getService(id) {

            const self = this;

            // await axios.get('/api/services-to-be-collected/' + id, {
            await axios.get('/api/services-to-be-collected/' + id + '/includefile', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(response => {

                if (response.status == 200) {

                    const data = response.data.data;
                    this.invoice_concepts = data.invoice_concepts;
                    this.shippings = this.enrichShippings(response.data.shippings || [])


                    /* ---------- archivo adjunto ---------- */
                    if (data.file) {
                        this.rawFile = data.file
                        this.mimeType = data.mime_type || ''
                        this.filename = data.filename || ''
                    } else {
                        /* sin adjunto ⇒ limpiamos */
                        this.rawFile = this.mimeType = this.filename = ''
                    }

                    this.$swal.close()
                    this.verModal = true;
                } else {
                    self.clients = [];
                }
            }).catch(function (error) {
                console.log(error);
                if (error.response.statusText == 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout'
                } else {
                    self.$swal.fire({
                        icon: "error",
                        title: "Error interno 1.1",
                        text: "Comuníquese con soporte.",
                        showConfirmButton: true,
                        showCancelButton: false
                    });

                }

            });
        },
        closeModal2() {
            this.verModal = false;
        },
        closeModal() {
            this.verHistorial = false;
        },
        editService(data) {
            window.location.href = '/serviciosCobrar/' + data.id_cs_fee;
        },
        formatCurrency(value, currencyCode = 'CLP') {
            console.log(value);
            return new Intl.NumberFormat('es-CL', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0 // O puedes cambiar el valor según lo que necesites
            }).format(value);
        },
        formatCurrencyIva(value, currencyCode = 'CLP') {
            const iva = +(value * 1.19).toFixed(2)

            return new Intl.NumberFormat('es-CL', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0 // O puedes cambiar el valor según lo que necesites
            }).format(iva);
        },
        updateCollapsed(value) {
            //  console.log('Evento recibido:', value); // Para depuración
            this.collapsed = value; // Actualiza el estado
        },
        updatePinned(value) {
            //  console.log('Evento recibido pinn:', value); // Para depuración
            this.pinned = value; // Actualiza el estado
        },
        showreq(id) {
            const self = this;
            // console.log(id);
        },
        getAR() {
            this.$swal({ title: 'Obteniendo servicios por cobrar' });
            this.$swal.showLoading();
            this.loading = true;

            const params = {
                page: this.page,
                per_page: this.perPage,
                rut: this.dataForm.rut.value,
                nroDespacho: this.dataForm.shipping_number.value,
                nroFactura: this.dataForm.document_number.value,
                nroReserva: this.dataForm.booking_number.value,
                monto: this.dataForm.amount.value,
                sort_by: this.sortColumn,
                sort_dir: this.sortDirection,
            };

            axios.post('/api/services-to-be-collected', params, {
                headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
            })
                .then(({ data, status }) => {
                    if (status === 200) {
                        this.items = data.data || [];
                        this.totalRows = Number(data.total ?? 0);
                        if (data.per_page) this.perPage = Number(data.per_page);       // opcional
                        if (data.current_page) this.page = Number(data.current_page);   // opcional
                    } else {
                        this.items = [];
                        this.totalRows = 0;
                    }
                })
                .catch(err => {
                    if (err.response?.statusText === 'Unauthorized') {
                        localStorage.removeItem('accessToken');
                        window.location.href = './../../api/auth/logout';
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.$swal?.close?.();
                });
        },

        /* formatea mientras escribe y sólo agrega el guion final */
        handleRutInput(e) {
            // 1. quitar caracteres no permitidos y pasar a mayúsculas
            const raw = e.target.value.replace(/[^0-9kK]/g, '').toUpperCase();

            // 2. si aún no hay suficiente largo, mostrar tal cual
            if (raw.length <= 1) {
                this.dataForm.rut.value = raw;
                this.dataForm.rut.err = false;
                return;
            }

            // 3. separar cuerpo y dígito verificador
            const cuerpo = raw.slice(0, -1);
            const dv = raw.slice(-1);

            // 4. concatenar con guion (sin puntos)
            this.dataForm.rut.value = `${cuerpo}-${dv}`;
            this.dataForm.rut.err = false;   // limpia error mientras escribe
        },

        async deleteFilters() {
            this.dataForm.document_number.value = '';
            this.dataForm.booking_number.value = '';
            this.dataForm.shipping_number.value = '';
            this.dataForm.rut.value = '';
            this.dataForm.amount.value = 0;

            // si limpias el DOM manualmente, hazlo después de actualizar el estado
            ['document_number', 'booking_number', 'shipping_number', 'rut', 'amount'].forEach(id => {
                const el = document.getElementById(id);
                if (el) el.value = id === 'amount' ? '0' : '';
            });

            this.page = 1;
            this.filter();

        }
    },
};
</script>

<style lang="css">
@import 'bootstrap';
@import 'datatables.net-bs5';



.cont-proveedor {
    height: 300px;
    overflow-y: scroll;
}
</style>